import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import {
  Box,
  FormControl,
  InputAdornment,
  TextField,
  InputLabel,
  Select,
  Button,
  MenuItem,
} from '@material-ui/core';
import dayjs from 'dayjs';
import { useIntl } from 'umi';
import DateRangePickerML from '@/components/DateRangePickerML';
import ClearIconML from '@/components/ClearIconML/index';
import webStorage from '@/utils/storageManager';
import SearchGroupStyled from './SearchGroupStyled';
import { createOid } from '@/utils/eventtracing';

const SearchGroup = (props) => {
  const sevenAfterDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
  const today = dayjs().format('YYYY-MM-DD');
  const intl = useIntl();
  const { formatMessage } = intl;
  const { query } = props;
  const MESSAGE_MY_TASK_STATUS = webStorage.get('DICTOBJ')
    ?.MESSAGE_MY_TASK_STATUS;
  const { handleSearch, restClick, searchRef } = props;
  const {
    startDate = sevenAfterDate,
    endDate = today,
    status,
    taskName,
    thirdTitle,
  } = query;
  const { handleSubmit, control, reset, setValue, watch, getValues } = useForm({
    defaultValues: {
      status,
      taskName,
      thirdTitle,
      date: { startDate, endDate },
    },
  });
  //控制日期控件的重置
  const [isResetDefalut, setIsResetDefalut] = useState(false);
  const watchStatus = watch('status');

  //查询
  const handleSearchClick = (values) => {
    const { date, ...restParam } = values;
    const searchParam = {
      ...restParam,
      startDate: date?.startDate,
      endDate: date?.endDate,
    };
    if (
      !searchParam.status &&
      !searchParam.taskName &&
      !searchParam.startDate &&
      !searchParam.endDate
    ) {
      window.message.toast({
        type: 'error',
        message: '请至少选择一个筛选条件',
      });
      return false;
    }
    handleSearch(searchParam);
  };
  //重置
  const handleResetClick = () => {
    const resetSearch = {
      date: { startDate: sevenAfterDate, endDate: today },
      thirdTitle: '',
      status: '',
      taskName: '',
      startDate: sevenAfterDate,
      endDate: today,
    };
    setIsResetDefalut(true);
    reset(resetSearch);
    restClick && restClick(resetSearch);
  };
  //置空状态
  const handleClearStatus = () => {
    setValue('status', '');
  };
  return (
    <SearchGroupStyled>
      <form onSubmit={handleSubmit(handleSearchClick)}>
        <Box className="search-wrapper">
          <Box className="left">
            <Box className="first-line">
              <Controller
                render={(rp) => (
                  <TextField
                    variant="standard"
                    autoComplete="false"
                    control={control}
                    onChange={(e) => {
                      setValue('taskName', e.target.value);
                      return rp.value;
                    }}
                    value={rp.value ?? ''}
                    id="basic"
                    className="campaignName"
                    label="任务名称"
                    defaultValue=""
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('taskName', '');
                            }}
                            edge="end"
                          >
                            {getValues('taskName') && (
                              <ClearIcon className="clear-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="taskName"
                control={control}
                id="basic"
                className="input"
              />
              <FormControl variant="standard" className="gender">
                <InputLabel>状态</InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('status', '')}
                              edge="end"
                            >
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {MESSAGE_MY_TASK_STATUS &&
                        MESSAGE_MY_TASK_STATUS.map((item) => (
                          <MenuItem
                            key={item.dictCode}
                            value={item.dictCode}
                            name={item.nameZh}
                          >
                            {item.nameZh}
                          </MenuItem>
                        ))}
                    </Select>
                  }
                  label="状态"
                  name="status"
                  variant="standard"
                  control={control}
                  defaultValue=""
                  className="status"
                />
                <ClearIconML
                  handleClick={handleClearStatus}
                  clearValue={watchStatus}
                ></ClearIconML>
              </FormControl>
              <FormControl variant="standard" className="date">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      label="任务时间"
                      startText="开始日期"
                      endText="结束日期"
                      defaultStartDate={startDate}
                      defaultEndDate={endDate}
                      rp={rp}
                      setValue={setValue}
                      onChange={() => setIsResetDefalut(false)}
                      isResetDefalut={isResetDefalut}
                      resetStartDate={sevenAfterDate}
                      resetEndDate={today}
                    />
                  )}
                  name="date"
                  control={control}
                />
              </FormControl>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleResetClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: createOid(),
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
};
export default SearchGroup;
